<template>
	<div v-show="bodyIsShow">
		<div class="bodywrap fonts">
			<header> 
				<input type="hidden" id="model_url" value="/Ajaxershouche/getCarModels?seriesid="/>
				<input type="hidden" id="series_url" value="/Ajaxershouche/getCarSeries?brandid="/>
			    <a class="fl searchHeader-back" href="javascript:window.history.go(-1)"></a>
			    <span class="title">完善信息</span> 
		    </header>
		    
		    <!-- 超级购活动开始--> 
		     <!--<if condition="($isBuy eq 1) ">-->
		       <a v-if="isBuy == 1"  class="clearfix" style="display:block;width:100%" :href="superBuyUrlPath">  
		         <img style="float:left;width:100%" :src="bannerPic" />     
		       </a>
		     <!--</if>-->
		   <!-- 超级购活动结束 -->
		    
		    <div class="ab_wrap">
			    <div class="ab_text">
				    <ul>
					    <li>提交报名<i class="blue">&gt;</i></li>
					    <li class="cur">完善信息<i class="blue">&gt;</i></li>
					    <li>报名成功</li>
				    </ul>
			    </div>
		    </div>
		    <div class="improve_form" >
		    	<form class="form" id="improve-car" onsubmit="return false;">
		    	
		    	<input type="hidden" id="brandId" name="brandId" :value="brandId"> <!-- 品牌信息 -->
		    	 <!-- 4s商圈 -->
		    	  <input type="hidden" id="getTradingAreasUrl" :value="getTradingAreasUrl"> <!--ajax获取商圈信息-->
		          <input type="hidden" id="areaCounty" name="areaCounty" value=""> <!--四级商圈-->
		    	   <input type="hidden" id="getCarColor" name="getCarColor" :value="getCarColor"><!-- 根据车款获取颜色 -->
		    	   <input type="hidden" name="opentime" :value="groupbuyDateReplace">
		    		<input type="hidden" name="opencity" :value="groupinfo.regular4sShop">
		    		<input type="hidden" id="tch_success" name='tch_success' :value="tch_success">
		    		<input type="hidden" name="openweek" :value="groupinfo.groupbuyWeek">
		    		<input type="hidden" id="cityIdCheck" :value="chengshi">
		    	    <input type="text" name="cityId" :value="chengshi" style="display: none;"/>
					<input type="text" name="id" id="a_id" :value="applyid" style="display: none;"/>   
					<input type="text" name="sk" :value="sk"  style="display: none;"/> 
					<input type="hidden" id="tch_url" name="tch_url" :value="tch_url" >
					<input type="hidden" name="tchInfosStr" :value="tchInfosStr" />
					
					<!--<input type="hidden" name="isBuy" value="isBuy"/> <!-- 是否有超级购 -->
					
					
					
					<!--<div v-if="isBuy == 1 ">-->
					<!--<input type="hidden" name="superBuyUrl" value="{$superBuyUrl}"/> <!-- 超级购url -->
					<!--<input type="hidden" name="bannerPic" value="{$bannerPic}"/>-->
					<!--</div>-->
					<!--<if condition="$buyType gt 0">-->
				    <input v-if="buyType > 0"  type="hidden" name="buyType" :value="buyType">
				    <!--</if>-->
		    		<div class="improve-tit">新车报名信息</div>	  
		    		
		    		 <!--  <div class="improve improve_last">
					   <input type="hidden" value="<notempty name='name'>{$name}</notempty>" name="username" class="username" placeholder="请输入姓名" />
				     </div> -->  	
				      <!-- 点击弹出完善地址页面 -->
			        <div class="Localarea marLeft Localareaview" id="Localarea">
			          <div class="ares">所在地区</div>
			           <em class="improve-arror"></em>
			        </div> 
				     <!-- 车款信息 -->
		            <!--<notempty name='cars'>-->
	               <div class="improve" v-if="responseData">     
		               <em class="improve-arror"></em>  
					    <select v-model="carId" class="selects carId" name="carId" id="carIds"
					     @change="selectCar()">
						    <option value="-1">意向车款</option>
						    	<!--<foreach name="cars" item="car" >-->
				                <option v-for="(item,index) in cars" :value="item.id">{{item.modelNameValue}}</option>
				                <!--</foreach>-->
					    </select> 
					    <span class="help-inline">
					    </span>      	
				    </div>
				   	<!--</notempty>-->
				   
				    <!-- 车款颜色 -->
		           <div class="improve"  v-if="responseData">     
		            <em class="improve-arror"></em>  
					    <select id='carColor' class="selects carColor" name="carColor">
						    <option value="null">车款颜色</option>
						    <option v-for="(item,index) in carColor" :value="item.name">{{item.name}}</option>			    	
					    </select> 
					    <span class="help-inline">
					    </span>      	
				    </div>
				    
		            <div class="improve">
		            	<em class="improve-arror"></em>    
					    <select id="time" class="selects getCarTime" name="getCarTime">
						   <option value="">购车时间</option>
                        	<option value="1">一周内</option>
                            <option value="5">半个月内</option>
                            <option value="2">一个月内</option>
                            <option value="3">三个月内</option>
                            <option value="7">不确定</option>
					    </select> 
				    </div>
				    
				    <!-- 看车途径 -->
		         <div class="improve">     
		          <em class="improve-arror"></em>  
					    <select class="selects carLookTuJing" name="carLookTuJing">
						    <option value="">看车途径</option>	
						    <option value="1">网络</option>	
						    <option value="2">4s店</option>
						    <option value="4">电视广告</option>		
						    <option value="3">其他</option>			    	
					    </select> 
					    <span class="help-inline">
					    </span>      	
				    </div>
				    
				     <!-- 是否分期 -->
					<!--<if condition="$splitMoney lt 0">-->
						<div v-if="splitMoney < 0"  class="improve">
							<em class="improve-arror"></em>
							<select class="selects fenQi" name="fenQi">
								<option value="">是否分期</option>
								<option value="1">是</option>
								<option value="0">否</option>
							</select>
							<span class="help-inline">
							</span>
						</div>
					<!--</if>-->
					<!--<if condition="$splitMoney gt -1">-->
						<input  v-if="splitMoney > -1" type="hidden" name="fenQi" :value="splitMoney">
					<!--</if>-->
				    
				    <div class="improve improve_last " id="padLeft">    
					   <input type="number" name="knowPrice" class="youhui" placeholder="请输入已知优惠" />
					   <label style="margin-right:1em; position: absolute;top:1em;right:0;" class="fr"><span 
				       class="sure-gray sure" 
					   ></span>不确定</label>
					    <span class="moneyfr">元</span>
				    </div>
					<!--
				    <div class="improve_img">
				    	<img class="scrollLoading" src="{$msite_static_url}/images/common/tuanBg-b.png" data-url="{$msite_static_url}/images/default/renrenche1.png" />
				    </div>
				    -->
				    <div  v-if="this.$route.query.buyway==1">
				    	<div class="improve-tit">旧车信息</div>
					    <div id="input-city" data-rel="city" class="improve">
					    	<em class="improve-arror"></em>    
						    <div id="renren-city-name" class="improve-txt">请选择城市</div>
						    <input id="renren-city-value" type="hidden" name="licensecity_id" value="" />
					    	 <input id="renren-city-text" type="hidden" name="licensecity" value="" />
					    </div>
					    <div id="input-car" data-rel="car" class="improve">
					    	<em class="improve-arror"></em>    
						    <div id="renren-kuan-name" class="improve-txt">请选择品牌</div>
						   
						    <input id="renren-brand-value" type="hidden" name="brand_id" value="" />
						    <input id="renren-style-value" type="hidden" name="series_id" value="" />
						    <input id="renren-kuan-value" type="hidden" name="model_id" value="" />
						    
						    <input id="renren-brand-text" type="hidden" name="brand_name" value="" />
						    <input id="renren-style-text" type="hidden" name="series_name" value="" />
						    <input id="renren-kuan-text" type="hidden" name="model_name" value="" />
					    </div>	    
					    <!-- <div class="improve">
					    	<em class="improve-arror"></em> 
						    <div id="improve-data-placeholder" class="improve-data-placeholder">请选择上牌时间</div>
						    <input id="improve-data" class="improve-data"  type="month" name="license_date" />
					    </div>-->
					    <div id="input-shangpai" class="improve">
							<em class="improve-arror"></em>
							<div id="improve-data-placeholder" class="improve-data-placeholder">请选择上牌时间</div>
							<input id="improve-data"  type="hidden" name="license_date" value="" />
						</div>
					    <div class="improve improve_last " id="padLeft">    
						    <input id="distance_new" type="tel" maxlength="6" name="kilometre" placeholder="请输入行驶里程" />
						    <span class="moneyfr">万公里</span>
					    </div>	
				    </div>
				    <div class="improve_x">
				    	<p class="gray"><span class="xieyi"></span><input id="result" type="hidden" value="1" /><a :href="msite_static_url+'/default/xieyi.html'">同意《个人信息保护声明》</a></p>
		        	    <input type="button" class="tc_hui" id="next" value="下一步" @click="nextSub">
				    </div>
		    	</form>
		    </div>
		</div>
		<div id="sider-mark" class="sider-mark"></div>
		
		<div id="sider-wrap" class="sider-wrap">
			  <!--城市-->
		      <div id="side-city" class="side-div side-city">
		      	<div class="side-header">
		      		<span class="side-back-all"></span>
			    	<span class="title">选择城市</span> 
		      	</div>
		      	<!--<foreach name="rrcCityList" key="k" item="city" >-->
		      	<div v-for="(item,index) in rrcCityList">
			      	<dl class="side-list">
			      		<dt class="side-list-dt">{{index}}</dt>
			      		<!--<foreach name="city" item="list">-->
			      		<dd v-for="(itemChild,index) in item"  class="side-list-dd" :data-rel="itemChild.id">{{itemChild.name}}</dd>
			      		<!--</foreach>-->
			      	</dl>
		      	</div>	
		      	<!--</foreach>-->
		      	
		      	<div class="ziMuBody">
		            <ul class="ziMuUl">
		            <!--<foreach name="rrcCityList" key="k" item="city" >-->
		      		<li  v-for="(item,index) in rrcCityList" class="zimu">{{index}}</li>
		            <!--</foreach>-->
		            </ul>
		        </div>
		      </div>
		      <!--城市-->
			  <!--品牌-->
		      <div id="side-brand" class="side-div side-brand">
		      	<div class="side-header"><span class="side-back-all"></span><span class="title">选择品牌</span></div>
		      	<!--<foreach name="rrcBrandList" item="brand" key="k" >-->
		      	<div v-for="(item,index) in rrcBrandList">
		      	<dl class="side-list">
		      		<dt class="side-list-dt">{{index}}</dt>
		      		<!--<foreach name="brand" item="list" >-->
		      		<dd v-for="(itemChildren,index) in item" class="side-list-dd" :data-rel="itemChildren.id">{{itemChildren.name}}</dd>
		      		<!--</foreach>-->
		      	</dl>
		      	</div>
		      	<!--</foreach>-->
		      	
		      	
		      	<div class="ziMuBody">
		            <ul class="ziMuUl">
		            <!--<foreach name="rrcBrandList" item="brand" key="k" >-->
			        <li v-for="(item,index) in rrcBrandList"  class="zimu">{{index}}</li>
			         <!--</foreach>-->
			         </ul>
			         
		        </div>        
		      </div>      
		      <!--品牌-->
		      <!--车型-->
		      <div id="side-carstyle" class="side-div side-carstyle">        
		      </div>
		      <!--车型-->
		      <!--车款-->
		      <div id="side-kuan" class="side-div side-kuan">        
		      </div>
		      <!--车款-->
		      
		      
		      
		      <!--年-->
		      <div id="side-year" class="side-div side-year">
		        <div class="side-header"><span class="side-back-all"></span><span class="title">选择年份</span></div>
		        <dl class="side-list">
		          <dt style="display:none">年份</dt>
		        </dl>        
		      </div>
		      <!--年-->
		      <!--月-->
		      <div id="side-month" class="side-div side-month">
		        <div class="side-header"><span class="side-back"></span><span class="title">选择年份</span></div>
		        <dl>
		          <dt style="display:none">月份</dt>
		          <dd month="01" class="side-list-dd">1月</dd>
		          <dd month="02" class="side-list-dd">2月</dd>
		          <dd month="03" class="side-list-dd">3月</dd>
		          <dd month="04" class="side-list-dd">4月</dd>
		          <dd month="05" class="side-list-dd">5月</dd>
		          <dd month="06" class="side-list-dd">6月</dd>
		          <dd month="07" class="side-list-dd">7月</dd>
		          <dd month="08" class="side-list-dd">8月</dd>
		          <dd month="09" class="side-list-dd">9月</dd>
		          <dd month="10" class="side-list-dd">10月</dd>
		          <dd month="11" class="side-list-dd">11月</dd>
		          <dd month="12" class="side-list-dd">12月</dd>
		        </dl>       
		      </div>
		      <!--月-->
		      
		</div>
		<!-- 4s店商圈开始 -->
		     <div class="wrapbox" id="wrapbox">
		        <!-- 头部开始 -->
		        <div class="header-top">
		            <header class="headbox placeFontsTitt">
		                <em class="icons" id="icons"></em>
		                <span>地址选择</span>
		            </header>
		        </div>
		        <section class="heade-ulwrap  smallFonts">
		            <div class="heade-ul  smallFonts">
		                <li style="display:none">
		                    <a href="javascript:;" class="bej">{{cityInfos.name}}</a>
		                    <b></b>
		                </li>
		                <li >
		                    <a href="javascript:;" class="bej"></a>
		                    <b></b>
		                </li>
		                 <li >
		                    <a href="javascript:;"  class="bej"></a>
		                    <b></b>
		                </li>
		                 <li class="pleaseChoose" style="display: block">
		                    <a href="javascript:;"  class="bej   smallFonts">请选择</a>
		                    <b></b>
		                </li>
		            </div>
		        </section>
		        <div class="addcontainer  smallFonts" id="addcontainer">
		            <ul id="add-ul0" class="add-ul add-ul0  smallFonts">
		              <!--<foreach name="topLevelTradingAreas" item="vo" >-->
		                <li  v-for="(item,index) in topLevelTradingAreas" :tareaid="item.tAreaId" :level="item.level+1" 
		                @click="areaPro(item.tArea,item.tAreaId,item.level+1)">{{item.tArea}}<em></em></li>
		              <!--</foreach>-->
		            </ul>
		            <ul class="add-ul add-ul1" id="add-ul1">

		            	<li  v-for="(item,index) in topLevelTradingCou" :tareaid="item.tAreaId" :level="item.level+1" 
		                @click="areaPro(item.tArea,item.tAreaId,item.level+1)">{{item.tArea}}<em></em></li>
		            </ul>
		            <ul class="add-ul add-ul2" id="add-ul2">
		            	<li  v-for="(item,index) in topLevelTradingPro" :tareaid="item.tAreaId" :level="item.level+1" 
		                @click="areaPro(item.tArea,item.tAreaId,item.level+1)">{{item.tArea}}<em></em></li>
		            </ul>
		            <ul class="add-ul add-ul3" id="add-ul3">
		            	<li  v-for="(item,index) in topLevelTradingDis" :tareaid="item.tAreaId" :level="item.level+1" 
		                @click="areaPro(item.tArea,item.tAreaId,item.level+1)">{{item.tArea}}<em></em></li>
		            </ul>
		        </div>
		
		      
		    </div>
		<!-- 4s店商圈结束 -->
	</div>
</template>
<style scoped>
	.fonts{
		font-size: 16px;
	}
	.smallFonts{
		font-size: 0.35rem;
	}
	.placeFontsTitt{
		font-size: 0.45rem;
	}
	.Localareaview{
		padding: 0.4rem 0;
	}
	.marLeft{
		margin-left: 0.25rem;
	}
	#padLeft{
		padding-left: 0.25rem !important;
	}
	
	
	
	.header {
	    height: 2em;
	    line-height: 2em;
	}
	.heade-ul li {
	    padding: 0.1rem 0.4rem;
	    line-height: 0.5rem;
	}
	.header-top em {
	    top: 0.7rem;
	    left: 0.4rem;
	    width: 0.5rem;
	    height: 0.5rem;
	}
	.heade-ul li b {
	    bottom: -0.3rem;
	    width: 1.5rem;
	    margin-left: 0.4rem;
	    height: 0.1rem;
	}
	.addcontainer .add-ul {
	    padding: 0.1rem 0.2rem;
	}
	.addcontainer .add-ul li {
	    height: 0.4rem;
	    line-height: 0.4rem;
	    padding-left: 0.2rem;
	}
	.addcontainer .add-ul li {
	    border-bottom: 1px solid #dcdcdc;
	    padding: 0.6rem;
	    padding-left: 0.3rem;
	}
	.heade-ul li {
	    list-style: none;
	    font-size: 0.35rem;
	    margin-top: 0.3rem;
	}
	.heade-ul{
	    height: 1.3rem;
	}
	.pleaseChoose a{
		margin-top: 0.5rem;
	}
	.side-header {
	    font-size: 0.4rem;
	}
	.side-div {
	    top: 5.3em;
	    font-size: 0.3rem;
	}
	.add-ul li{
		font-size: 14px;
	}
	.heade-ul li {
    	margin-right: -1rem;
	}
</style>
<script>
	export default {
	name: 'infomation',
	data:function() {
		return {
			bodyIsShow:false,
			model_url:'',
			series_url:'',
			isBuy: 1,
			superBuyUrlPath: "www.baidu.com",
			bannerPic: "",
			host_name: '',
			getTradingAreasUrl: '',
			brandId: '',
			getCarColor: '',
			chengshi: '',
			applyid: '',
			sk: '',
			k:'',
			groupinfo: {
				groupbuyDate: "dgssa",
				regular4sShop: '',
				groupbuyWeek: ''
			},

			tch_url: '',
			tchInfosStr: '',
			superBuyUrl: '',
			car: [{
				name: '',
				id: ''
			}],
			buyType: 2,
			splitMoney: 1,
			msite_static_url: 'http://static3.tuanche.com/wap01/dist',
			tch_success: '',
			city:[{
				city_id:1,
				city_name:'111'
			},{
				city_id:2,
				city_name:'222'
			},{
				city_id:3,
				city_name:'333'
			}],
			topLevelTradingAreas:[],
			topLevelTradingCou:[],
			topLevelTradingPro:[],
			topLevelTradingDis:[],
			cars:[],
			carId:-1,
			carColor:[],
			cityInfos:'',
			rrcCityList:[],
			rrcBrandList:{},
			tradingArea:{
				result : "",
			    tradingArea1 : '', //一级商圈
			    tradingArea2 : '', //二级商圈
			    tradingArea3 : '', //三级商圈
			    tradingArea4 : '', //四级商圈
			    tradingName:[]
			},
			responseData:null
			
		}
	},
	beforeCreate: function() {
		getCommonJsIns.initCSSwap02({
			cssURL: "/css/commons/common.css"
		});
		getCommonJsIns.initCSSwap02({
			cssURL: "/css/default/improve-renren.css"
		});
	},
	mounted: function() {
		var self = this;
		document.title = "品牌";
		getCommonJsIns.initDefaultJS(self.webReady);
//		getCommonJsIns.initJSwap02({
//			jsURL: "/script/default/improveinfor-renren.js",
//			callback: function() {
//				self.webReady()
//			}
//		});

	},
	computed: {
		groupbuyDateReplace: function() {
			return this.groupinfo['groupbuyDate'].replace('开团', '');
		}
	},
	methods: {
		webReady: function() {

			var self = this;
			this.bodyIsShow = true;
			this.ajaxSubmit.ajax({
				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.getAreaList,
				//url:"http://oo.tuanche.com:8083/data/data.js"
				type:"get",
				dataType:"json",
				success:function(data){
					var result = data.response.result;
					if(data.responseHeader.status == 200){
						self.topLevelTradingAreas=result;
					}
				},
				error:function(){

				}
			});
			this.ajaxSubmit.ajax({
				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcModel+"?styleId="+self.$route.query.carStyleId,
				//url:"http://oo.tuanche.com:8083/data/data.js"
				type:"get",
				dataType:"json",
				success:function(data){
					var result = data.response.result;
					self.responseData=result;
		
					if(data.responseHeader.status == 200&&result){
						
						self.cars=result.modelList;
						// self.getStyleCar();

						// for(var key in result.modelList){
						// 	self.cars[key].id=result.modelList[key].id;
						// }
					}
				},
				error:function(){

				}
			});
			this.ajaxSubmit.ajax({
				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcBrand,
				//url:"http://oo.tuanche.com:8083/data/data.js"
				type:"get",
				dataType:"json",
				data:{
					cityId:this.$route.query.cityId
				},
				success:function(data){
					var result = data.response.result;
					if(data.responseHeader.status == 200){
						self.rrcBrandList=result;
					}
				},
				error:function(){

				}
			});
			this.ajaxSubmit.ajax({
//				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcCitys,
				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.openCitys,
				type:"get",
				dataType:"json",
				success:function(data){
					var result = data.response.result;
					if(data.responseHeader.status == 200){
						self.rrcCityList=result.openCitys
					}
					getCommonJsIns.loadJs(pathWap01 + "/script/default/improveinfor-renren.js",function(){});

				},
				error:function(){

				}
			});

		},
		areaPro:function(tAreaNameData,tAreaIdData,levelData){
				//alert(levelData);
				var self = this;
			    this.ajaxSubmit.ajax({
				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.getAreaList+"?level="+levelData+"&tAreaId="+tAreaIdData,
				//url:"http://oo.tuanche.com:8083/data/data.js"
				type:"get",
				dataType:"json",
				success:function(data){
					var result = data.response.result;
					if(data.responseHeader.status == 200){
						if(levelData==1){
							for(var i in result){
								self.topLevelTradingCou.push(result[i]);
							}
							self.tradingArea.tradingName[0] = tAreaNameData;
							self.tradingArea.tradingArea1 = tAreaIdData;
							self.tradingArea.tradingArea2 = "";
							self.tradingArea.tradingArea3 = "";
							self.tradingArea.tradingArea4 = "";
							self.tradingArea.tradingName[1] = "";
							self.tradingArea.tradingName[2] = "";
							self.tradingArea.tradingName[3] = "";
						}else if(levelData==2){
							for(var i in result){
								self.topLevelTradingPro.push(result[i]);
							}
							self.tradingArea.tradingName[1] = tAreaNameData;
							self.tradingArea.tradingArea2 = tAreaIdData
							self.tradingArea.tradingArea3 = "";
							self.tradingArea.tradingArea4 = "";
							self.tradingArea.tradingName[2] = "";
							self.tradingArea.tradingName[3] = "";
						}else if(levelData==3){
							for(var i in result){
								self.topLevelTradingDis.push(result[i]);
							}
							self.tradingArea.tradingName[2] = tAreaNameData;
							self.tradingArea.tradingArea3 = tAreaIdData
							self.tradingArea.tradingArea4 = "";
							self.tradingArea.tradingName[3] = "";
						}else if(levelData==4){
							self.tradingArea.tradingName[3] = tAreaNameData;
							self.tradingArea.tradingArea4 = tAreaIdData
						}
						if(result.length == 0 ){
							$("#Localarea .ares").text(self.tradingArea.tradingName.join(""));
							$(".wrapbox").animate({
					            left: '-100%'
					        }, 200);
						}
						self.tradingArea.result = self.tradingArea.tradingArea1 + '@#' + self.tradingArea.tradingArea2 + '@#' + self.tradingArea.tradingArea3 + '@#' + self.tradingArea.tradingArea4; //拼接
                    	$("#areaCounty").val(self.tradingArea.result);
					}
				},
				error:function(){}
			});
			
		},
		// getStyleCar:function(){
		// 	var self =this;
		// 	$("#side-brand").delegate(".side-list-dd", "click", function() {

		//         var brandId = $(this).data("rel");
		//         var brandName = $(this).text();
		//         $(this).closest(".side-div").css("display", "none");
		//         $("#side-carstyle").css("display", "block").html("<div class='seo-loading'>正在加载，请稍后</div>");
		//         $("#side-carstyle").css("display", "block");
		//         self.ajaxSubmit.ajax({
		// 			url:self.commmonWebConfig.tuancheapi+self.ajaxSubmit.allUrl.baseDataTcStyle+"?brandId="+brandId,
		// 			//url:"http://oo.tuanche.com:8083/data/data.js"
		// 			type:"get",
		// 			dataType:"json",
		// 			success:function(data){
		// 				$("#side-brand").data("dada", brandId);
		//                 $("#side-brand").data("name", brandName);
		//                 var header = '<div class="side-header">' +
		//                     '<span class="side-back"></span>' +
		//                     '<span class="title">选择车型</span>' +
		//                     '</div>';
		//                 var contentStr = "";
		//                 for(var i in data.response.result){
		//                 //if(data[i].length>0){                       
		// 	                contentStr += '<dl class="side-list">'
		// 	                for (var j in data.response.result[i].styleList) {
		// 	                    contentStr += '<dd class="side-list-dd" data-rel="' + data.response.result[i].styleList[j].id + '">' + data.response.result[i].styleList[j].styleName + '</dd>';
		// 	                }
		// 	                contentStr += '</dl>';
		//                 //}
		//                 };
		//                 $("#side-carstyle").html(header + contentStr);
		//                 self.getCarModels();
		// 			},
		// 			error:function(){
		// 				$(this).closest(".side-div").css("display", "none");
		//                 $("#side-brand").hide();
		//                 alert("系统忙，请稍后");
		// 			}
		// 		});
		//     })
		// },
		// getCarModels:function(){
		
		// 		var self = this;
		// 		$("#side-carstyle").delegate(".side-list-dd", "click", function() {
		//         var carstyleid = $(this).data("rel");
		//         var carstylename = $(this).text();
		//         $(this).closest(".side-div").css("display", "none");
		//         $("#side-kuan").css("display", "block").html("<div class='seo-loading'>正在加载，请稍后</div>");
		//         $("#side-kuan").css("display", "block");

		//         self.ajaxSubmit.ajax({
		// 			url:self.commmonWebConfig.tuancheapi+self.ajaxSubmit.allUrl.tcModel+"?styleId="+carstyleid,
		// 			//url:"http://oo.tuanche.com:8083/data/data.js"
		// 			type:"get",
		// 			dataType:"json",
		// 			success:function(data){
		// 				$("#side-carstyle").data("dada", carstyleid);
		// 				$("#side-carstyle").data("name", carstylename);
		// 				debugger;
		// 				console.log(data)
		//                 var count = 0;
		//                 var header = '<div class="side-header">' +
		//                     '<span class="side-back"></span>' +
		//                     '<span class="title">选择车款</span>' +
		//                     '</div>';
		//                 var tabStr = "<div id='tab-kuan' class='tab-kuan'>";
		//                 var contentStr = "";
		//                 //for(var i in data){
		//                 //tabStr+='<span class="tab-kuan-click">'+i+'</span>';
		//                 //count+=1;                                          
		//                 contentStr += '<dl style="display:none;" class="side-list">';
		//                 //'<dt style="display:none;" class="side-list-dt">'+i+'</dt>';
		//                 for (var j in data.response.result.modelList) {
		//                     contentStr += '<dd class="side-list-dd" data-rel="' + data.response.result.modelList[j].id + '">' + data.response.result.modelList[j].modelName + '</dd>';
		//                 }
		//                 contentStr += '</dl>';
		//                 //};
		//                 $("#side-kuan").html(header + tabStr + contentStr);
		//                 $("#tab-kuan .tab-kuan-click").eq(0).addClass("tab-kuan-click-cur");
		//                 $("#side-kuan .side-list").eq(0).attr("style", "display:block");
		//                 $("#tab-kuan .tab-kuan-click").each(function() {
		//                     $(this).css("width", 100 / count + '%')
		//                 });
		//                 $("#tab-kuan").delegate(".tab-kuan-click", "click", function() {
		//                     var index = $(this).index();
		//                     $(this).addClass("tab-kuan-click-cur").siblings(".tab-kuan-click").removeClass("tab-kuan-click-cur");
		//                     $("#side-kuan .side-list").attr("style", "display:none").eq(index).attr("style", "display:block");
		//                 })
		//                 $("#side-kuan").delegate(".side-list-dd", "click", function() {
		// 			        $("#renren-brand-value").val($("#side-brand").data("dada"));
		// 			        $("#renren-style-value").val($("#side-carstyle").data("dada"));
		// 			        $("#renren-kuan-value").val($(this).data("rel"));
		// 			        $("#renren-brand-text").val($("#side-brand").data("name"));
		// 			        $("#renren-style-text").val($("#side-carstyle").data("name"));
		// 			        $("#renren-kuan-text").val($(this).text());
		// 			        $("#renren-kuan-name").text($(this).text());
		// 			        $("#renren-kuan-name").addClass("black");
		// 			        $("#sider-wrap,#sider-mark,#side-brand,#side-carstyle,#side-kuan").attr("style","display:none");
		// 			        $("body").css("position","static")
		// 			    });
		// 			},
		// 			error:function(){
		// 				$(this).closest(".side-div").css("display", "none");
		//                 alert("系统忙，请稍后");
		// 			}
		// 		});
		//     });
		// },
		nextSub:function(){
			var self=this;
			//$(".tc_hui").attr("disabled","disabled");
			var dataApply = {
				"applyId":self.$route.query.applyId,
				"brandId":self.$route.query.brandId,
				"areaProvince":self.tradingArea.result.split("@#")[0],
				"areaCity":self.tradingArea.result.split("@#")[1],
				"areaDistrict":self.tradingArea.result.split("@#")[2],
				"areaCounty":self.tradingArea.result.split("@#")[3],
			    "carColor":$("#carColor option:selected").val(),
				"getcartime":$("#time option:selected").val(),
				"lookWay":$(".carLookTuJing option:selected").val(),
				"knowPrice":$(".youhui").val(),
				"cityId":self.$route.query.cityId,
//				"sk":
				"carStyleId":self.$route.query.carStyleId,
				"sk":self.$route.query.sk
			};
			var self = this;
			this.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.supplementForM,
				type:"post",
				dataType:"json",
				data:dataApply,
				success:function(data){
					var result = data.response.result;
					if(data.responseHeader.status == 200){
						if(self.$route.query.buyway == 1){
							var dataRR = {
								"tcapplyId":self.$route.query.applyId,
								"licensecityId":$("#renren-city-value").val(),
								"licensecity":$("#renren-city-text").val(),
								"seriesId":$("#renren-style-value").val(),
								"modelId":$("#renren-kuan-value").val(),
								"brandName":$("#renren-brand-text").val(),
								"seriesName":$("#renren-style-text").val(),
								"modelName":$("#renren-kuan-text").val(),
								"licenseDate":$("#improve-data").val(),
								"kilometre":$("#distance_new").val(),
							};
							dataRR = JSON.stringify(dataRR);
							self.ajaxSubmit.ajax({
								url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.saveRRcarInfo,
								type:"post",
								contentType: 'application/json',
								dataType:"json",
								data:dataRR,
								success:function(data){
									var result = data.response.result;
									console.log(result);
									if(data.responseHeader.status == 200){
										window.location.href = context + "/GroupBuy/addInfo"
									}
								},
								error:function(){}
							});
						}else{
							window.location.href = context + "/GroupBuy/addInfo"
						}	
					}
				},
				error:function(){

				}
			});
		},
		selectCar:function(){
			var self = this;
			for(var key in this.cars){
				//alert(carId);
				//console.log(this.cars[key].id);
				if(this.cars[key].id==this.carId){
					this.carColor = [];
					console.log(this.cars[key].carcolors);
					this.cars[key].carcolors = JSON.parse(this.cars[key].carcolors);
					console.log(this.cars[key].carcolors);
					for(var p in this.cars[key].carcolors){
						//alert(p);
						this.carColor.push(this.cars[key].carcolors[p])
					}
					//this.carColor=this.cars[key].colors;
					/*有相同车型*/
					return
				}
				
			}
		}

	}
}</script>


// WEBPACK FOOTER //
// src/views/signupPhp/infomation.vue